import $ from '@vaersaagod/tools/Dom';
import Components from '@vaersaagod/tools/Components';
import request from '@vaersaagod/tools/request';
import Viewport from '@vaersaagod/tools/Viewport';
import Navigator from '../modules/Navigator';

export default el => {
    const dom = $(el);
    const loaded = [];
    
    let currentOpen;
    let hasModal = false;
    let backTriggered = false;
    
    const showContent = content => {
        document.addEventListener('keyup', keyup);
        currentOpen = content;
        hasModal = true;
        
        const windowHeight = Viewport.size.height;
        const yOffset = Math.round(windowHeight / 8);
        
        const innerContent = $(content).find('[data-content]');
        const $closeWrap = $(content).find('[data-content-closewrap]');
        const $closeMouseFollow = $(content).find('[data-mousefollow-close]');
        const $heading = $(content).find('[data-content-heading]');
        const $text = $(content).find('[data-content-textwrap]');
        const $images = $(content).find('[data-content-image]');

        TweenMax.set(content, { display: 'block', opacity: 0 });
        TweenMax.set($heading.nodes, { opacity: 0 });
        TweenMax.set($text.nodes, { opacity: 0 });
        TweenMax.set($images.nodes, { y: yOffset, opacity: 0 });
        TweenMax.set($closeWrap.nodes, { opacity: 0 });
        
        TweenMax.to(content, 0.3, { opacity: 1, ease: Sine.easeOut });
        
        TweenMax.to($heading.nodes, 0.5, { delay: 0.6, opacity: 1, ease: Sine.easeOut });
        TweenMax.to($text.nodes, 0.5, { delay: 0.6, opacity: 1, ease: Sine.easeOut });
        TweenMax.to($closeWrap.nodes, 0.5, { delay: 2, opacity: 1, ease: Sine.easeOut });
        
        $images.nodes.forEach((el, i) => {
            TweenMax.to(el, 0.7, { delay: 1.2 + (i*0.3), opacity: 1, ease: Sine.easeInOut });
            TweenMax.to(el, 1.2, { delay: 1.2 + (i*0.3), y: 0, ease: Expo.easeOut });
        });
        
    };

    const hideContent = () => {
        if (window.history) {
            Navigator.setBackTriggered();
            window.history.back();
        }

        const itemToHide = currentOpen;
        document.removeEventListener('keyup', keyup);
        currentOpen = null;
        hasModal = false;

        const innerContent = $(itemToHide).find('[data-content]');
        TweenMax.to(innerContent.nodes, 0.3, { opacity: 0, ease: Sine.easeOut });
        TweenMax.to(itemToHide, 0.5, { delay: 0.4, opacity: 0, ease: Sine.easeOut, clearProps: 'all', onComplete: () => {
            TweenMax.set(innerContent.nodes, { opacity: 1, ease: Sine.easeOut });
        } });
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (hasModal && key === 27) {
            hideContent();
        }
    };

    const loadContent = (url, id) => {
        if (window.history) {
            window.history.pushState(null, null, url);
        }
        
        request.get(url).then(res => {
            const { text } = res || {};
            const container = document.createElement('div');
            $(container).append($(text).html()).addClass('d-n pos-f u-fill u-touch-scroll z-999 w-100');
            $(container).find('.lazyload').addClass('lazypreload');
            dom.append(container);
            loaded[id] = container;
            showContent(container);
            Components.parse(container);
        }, error => {
            console.error(error);
        });
    };

    const onClose = e => {
        e.preventDefault();
        hideContent();
    };

    const onClick = e => {
        e.preventDefault();
        const node = e.triggerTarget;
        const id = $(node).data('ajax-load');
        if (id in loaded) {
            showContent(loaded[id]);
        } else {
            loadContent(node.href, id);
        }
    };

    const onContentClick = e => {
        const $clickedElement = $(e.target).nodes[0];
        
        if ($clickedElement && $clickedElement.tagName !== 'IMG' && $clickedElement.tagName !== 'A') {
            hideContent();
        }
    };
    
    const init = () => {
        dom.on('click', '[data-ajax-load]', onClick);
        dom.on('click', '[data-ajax-close]', onClose);
        dom.on('click', '[data-content]', onContentClick);
    };

    const destroy = () => {
        //dom.off('click', '[data-ajax-load]', onClick);
        //dom.off('click', '[data-ajax-close]', onClose);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ModalContent.js